module.exports = __webpack_public_path__ + "img/024c164.jpg";